import { cn } from '@verlo/shared/lib/utils';

/**
 * A dish's or a section's route through the kitchen: tap the stations in the order the food
 * goes through them and each takes the next number; tap one again to take it out. The pass
 * is not a choice: every route ends there (Martin, Oct 2026), so it is said, not offered.
 */
const RoutePicker = ({ stations = [], value = [], onChange, disabled = false, testId = 'route' }) => {
  const toggle = (key) => onChange(value.includes(key) ? value.filter((k) => k !== key) : [...value, key]);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
      {stations.map((st) => {
        const at = value.indexOf(st.key);
        const on = at >= 0;
        return (
          <button
            key={st.key}
            type="button"
            disabled={disabled}
            onClick={() => toggle(st.key)}
            aria-pressed={on}
            className={cn(
              'inline-flex h-9 items-center gap-2 rounded-full border pl-1.5 pr-3 text-[13.5px] transition-colors disabled:opacity-50',
              on ? 'border-verlo bg-verlo-tint font-semibold text-verlo' : 'border-hairline bg-white text-ink-soft hover:border-ink-faint',
            )}
            data-testid={`${testId}-${st.key}`}
          >
            <span className={cn(
              'grid h-6 w-6 place-items-center rounded-full text-[11.5px] font-bold tabular-nums',
              on ? 'bg-verlo text-white' : 'border border-dashed border-hairline',
            )}>{on ? at + 1 : ''}</span>
            {st.name}
          </button>
        );
      })}
      <span className="text-[12.5px] text-ink-faint">{value.length ? 'then the Pass' : 'Straight to the Pass'}</span>
    </div>
  );
};

export default RoutePicker;
